import { NgFor, NgIf } from '@angular/common';
import {
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { ConfigurationService } from '@sc/data-access-configuration';
import { TranslatorService } from '@sc/data-access-translation';
import { DossierAbandonOutputData } from '@sc/data-access-models';
import { ButtonComponent } from '../button';
import { IconComponent } from '../icon';

@Component({
  selector: 'sc-abandon-dossier-sheet',
  styleUrls: ['./abandon-dossier-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    NgIf,
    NgFor,
    FormsModule,
    IconComponent,
    ButtonComponent,
    MatSelectModule,
    MatInputModule,
    TranslateModule,
  ],
  template: `
    <div class="abandon-dossier-container">
      <div class="close">
        <button
          type="button"
          class="close-btn"
          (click)="onButtonClick('cancel')"
        >
          <span class="sr_only">{{
            'GlobalApplicativeConstants.accessibility.closeDialog'
              | translate
                : { dialogTitle: 'AbandonDossierSheet.mainTitle' | translate }
          }}</span>
          <sc-icon name="close"></sc-icon>
        </button>
      </div>
      <span class="delete-icon">
        <sc-icon name="delete"></sc-icon>
      </span>
      <h1
        class="sc-design-title-h2"
        mat-dialog-title
        id="abandon-dossier-title-id"
        [innerHTML]="'AbandonDossierSheet.mainTitle' | translate"
      ></h1>
      <h2 class="sc-design-text-3">
        {{ 'AbandonDossierSheet.subTitle' | translate }}
      </h2>

      <mat-form-field
        class="center-input no-hint mb-l border-form"
        appearance="outline"
        *ngIf="getCommentOptions().length > 0"
      >
        <mat-select
          (selectionChange)="onSelectCommentOption($event)"
          class="resources mb-l"
          panelClass="mat-option-customs"
        >
          <mat-option
            *ngFor="let commentOption of getCommentOptions()"
            [value]="commentOption"
          >
            {{
              'GlobalApplicativeConstants.AbandonComment.Insurer.' +
                commentOption | translate
            }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <textarea
        *ngIf="allowFreeTextComment()"
        matInput
        #abandonedcommenttext
        [(ngModel)]="abandonmentComment"
      ></textarea>
      <div class="button-container">
        <sc-button
          id="abandonBtn"
          buttonType="error"
          [disabled]="!abandonmentComment"
          (click)="onButtonClick('success')"
          >{{ 'AbandonDossierSheet.abandonButton' | translate }}</sc-button
        >

        <sc-button
          id="laterBtn"
          buttonType="primary"
          (click)="onButtonClick('later')"
          >{{ 'AbandonDossierSheet.laterButton' | translate }}</sc-button
        >
        <sc-button
          id="cancelBtn"
          buttonType="secondary"
          (click)="onButtonClick('cancel')"
          >{{ 'AbandonDossierSheet.cancelButton' | translate }}</sc-button
        >
      </div>

      <div class="sc-conf-display-cancel-link-btn">
        <sc-icon name="arrow_right"></sc-icon>
        <a
          class="sc-design-button"
          (click)="$event.preventDefault(); onButtonClick('cancel')"
          >{{ 'AbandonDossierSheet.cancelButton' | translate }}</a
        >
      </div>
    </div>
  `,
})
export class AbandonDossierSheetComponent {
  @Output()
  private readonly abandonCommentResult = new EventEmitter<DossierAbandonOutputData>();

  abandonmentComment: string;

  constructor(
    private readonly configService: ConfigurationService,
    private readonly translator: TranslatorService
  ) {}

  getCommentOptions() {
    return (
      this.configService.getConfig().abandonComment?.insurer?.options || []
    );
  }

  allowFreeTextComment() {
    return (
      this.configService.getConfig().abandonComment?.insurer?.allowFreeText ??
      true
    );
  }

  onSelectCommentOption(newSelection: { value: string }) {
    this.abandonmentComment = this.translator.getInstantTranslation(
      `GlobalApplicativeConstants.AbandonComment.Insurer.${newSelection.value}`
    );
  }

  onButtonClick(clickEvent) {
    if (clickEvent === 'success') {
      this.abandonCommentResult.emit({
        type: clickEvent,
        abandonmentComment: this.abandonmentComment,
      });
    } else if (clickEvent === 'later') {
      this.abandonCommentResult.emit({
        type: clickEvent,
        finishLaterComment: this.abandonmentComment,
      });
    } else {
      this.abandonCommentResult.emit({ type: clickEvent });
    }
  }
}
